import React from "react";
import PropTypes from "prop-types";
import { Text } from "native-base";

function Cell(props) {
  const { children, header, ...rest } = props;

  if (header) {
    return (
      <th>
        {typeof children === "string" ? (
          <Text bold {...rest}>
            {children}
          </Text>
        ) : (
          children
        )}
      </th>
    );
  }

  return (
    <td>
      {typeof children === "string" ? (
        <Text {...rest}>{children}</Text>
      ) : (
        children
      )}
    </td>
  );
}

Cell.propTypes = {
  children: PropTypes.any,
  header: PropTypes.bool,
};

export default React.memo(Cell);
